import { queryOptions, useQuery } from '@tanstack/react-query';

import { KentInstallScriptOptions } from '@cast/types-kent';

import { apiClient } from '@cast/infrastructure-api';
import { useOrganizations } from '@cast/shared-organization-context-data-access';

const KENT_ORGANIZATION_INSTALL_SCRIPT_QUERY_KEY =
  'kent-organization-install-script';

const getOrganizationInstallScriptQueryKey = (
  organizationId?: string,
  requestData?: KentInstallScriptOptions
) =>
  [
    KENT_ORGANIZATION_INSTALL_SCRIPT_QUERY_KEY,
    organizationId,
    requestData,
  ] as const;

const getOrganizationInstallScriptQueryOptions = ({
  organizationId,
  requestData,
  enabled = true,
}: {
  organizationId?: string;
  requestData: KentInstallScriptOptions;
  enabled?: boolean;
}) =>
  queryOptions({
    queryKey: getOrganizationInstallScriptQueryKey(organizationId, requestData),
    queryFn: async () => {
      const { data } = await apiClient.kent.getOrganizationInstallScript({
        organizationId: organizationId ?? '',
        installScriptOptions: requestData,
      });

      // TODO:(Daniel): remove casting once API is updated
      // https://castai.atlassian.net/browse/UI-5395
      return (data as unknown as string) || '';
    },
    enabled: enabled && !!organizationId,
  });

type Params = {
  requestData: KentInstallScriptOptions;
  enabled?: boolean;
};

export const useGetOrganizationInstallScriptQuery = ({
  requestData,
  enabled = true,
}: Params) => {
  const { currentOrganization } = useOrganizations();

  return useQuery(
    getOrganizationInstallScriptQueryOptions({
      organizationId: currentOrganization?.id,
      requestData,
      enabled,
    })
  );
};
